import { httpClient } from '@/api/http';

const COUNTRY_CODE = 'IN';

export interface LocationState {
  name: string;
  code: string;
}

export interface LocationCity {
  name: string;
}

export async function getStates(search?: string): Promise<LocationState[]> {
  const { data } = await httpClient.get<LocationState[]>('/location/states', {
    params: { countryCode: COUNTRY_CODE, search: search || undefined },
  });
  return data;
}

export async function getCities(stateCode: string, search?: string): Promise<LocationCity[]> {
  const { data } = await httpClient.get<LocationCity[]>('/location/cities', {
    params: { countryCode: COUNTRY_CODE, stateCode, search: search || undefined },
  });
  return data;
}
